export const checkChairmanOrComissioner = (
  positionId: string | number,
): boolean => {
  if (positionId?.toString() === "1" || positionId?.toString() === "2") {
    return true;
  }
  return false;
};
